import jQuery from 'jquery';
(function ($) {
    function initAutocomplete() {
        console.log('initAutocomplete called');

        let addressLookupField = document.querySelector('#StreetAddress');
        if (addressLookupField && google) {
            let autocompleteElement = new google.maps.places.Autocomplete(addressLookupField, {
                componentRestrictions: { country: ['ca'] },
                fields: ['address_components', 'geometry'],
                types: ['address'],
            });
            // When the user selects an address from the drop-down, populate the
            // address fields in the form.
            autocompleteElement.addListener('place_changed', function () {
                fillInAddress(this, addressLookupField);
            });
        }
    }

    function fillInAddress(thisElement, addressLookupFieldElement) {
        console.log(thisElement);
        // Get the place details from the autocomplete object.
        const place = thisElement.getPlace();
        let dataAttributes = addressLookupFieldElement.dataset;
        if (dataAttributes) {
            let address1controlid = dataAttributes['address1controlid'];
            let postalcodecontrolid = dataAttributes['postalcodecontrolid'];
            let citycontrolid = dataAttributes['citycontrolid'];
            let longitudecontrolid = dataAttributes['longitudecontrolid'];
            let latitudecontrolid = dataAttributes['latitudecontrolid'];
            console.log(place);
            let address1 = '';
            let postcode = '';
            let locality = '';
            let state = '';
            let country = '';
            let longitude;
            let latitude;
            if (place.geometry?.location) {
                longitude = place.geometry?.location.lng();
                latitude = place.geometry?.location.lat();
            }
            for (const component of place.address_components) {
                const componentType = component.types[0];

                switch (componentType) {
                    case 'street_number': {
                        address1 = `${component.long_name} ${address1}`;
                        break;
                    }

                    case 'route': {
                        address1 += component.short_name;
                        break;
                    }

                    case 'postal_code': {
                        postcode = `${component.long_name}${postcode}`;
                        break;
                    }

                    case 'postal_code_suffix': {
                        postcode = `${postcode}-${component.long_name}`;
                        break;
                    }
                    case 'locality':
                        locality = component.long_name;
                        break;
                    case 'administrative_area_level_1': {
                        state = component.short_name;
                        break;
                    }
                    case 'country':
                        country = component.long_name;
                        break;
                }
            }
            populateTextFieldById(address1controlid, address1);
            populateTextFieldById(postalcodecontrolid, postcode);
            populateTextFieldById(longitudecontrolid, longitude);
            populateTextFieldById(latitudecontrolid, latitude);
            populateSelectFieldByIdWithTextMatch(citycontrolid, locality);
        }
    }
    function populateTextFieldById(elementId, text) {
        if (text) {
            let inputElement = document.getElementById(elementId);
            if (inputElement) {
                inputElement.value = text;
            }
        }
    }
    function populateSelectFieldByIdWithTextMatch(elementId, text) {
        if (text) {
            let selectElement = document.getElementById(elementId);
            if (selectElement) {
                let selectOptions = Array.from(selectElement.options);
                const optionToSelect = selectOptions?.find((item) => item.text === text);
                optionToSelect.selected = true;
            }
        }
    }
    window.initAutocomplete = initAutocomplete;
})(jQuery);
